import * as React from 'react';
import { Dots } from 'react-activity';
import styled from 'styled-components';

import IViewProps from '../IViewProps';

function UnstyledLoadingScreen(props: IViewProps) {
  return (
    <section className={props.className}>
      <Dots size={30} />;
    </section>
  );
}

const LoadingScreen = styled(UnstyledLoadingScreen)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/LoadingScreen.tsx